import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/scroll.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { AuthProvider } from "./auth/AuthContext.jsx";
import Home from "./pages/home.jsx"; // Ensure correct case
import No from "./pages/noPage.jsx"; // Ensure correct case
import Summer from "./pages/summer.jsx"; // Ensure correct case
import Main from "./pages/main.jsx"
import Login from "./pages/login.jsx";
import AdminDashboard from "./pages/admin.jsx";
import PropertyAdmin from "./pages/propertyAdmin.jsx";
import UnitAdmin from "./pages/unitAdmin.jsx";
import PublicPropertyPage from "./pages/publicProperty.jsx";
import "./main.css"; // Bootstrap (consider moving to index.js)

function App() {

  
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop/>
        <div> 
          <Routes>
            <Route index element={<Home />} />
            <Route path="/Summer" element={<Summer />} />
            <Route path="/Main" element={<Main />} />
            <Route path="/properties/:propertySlug" element={<PublicPropertyPage />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/:propertySlug"
              element={
                <ProtectedRoute>
                  <PropertyAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/:propertySlug/units/:unitId"
              element={
                <ProtectedRoute>
                  <UnitAdmin />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<No />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
